import React from "react"
import { useList } from 'effector-react'
import useLocationChange from "hooks/useLocationChange"
import invoiceSidebars from "stores/invoiceSidebars"
import InvoiceSidebar, { IInvoiceSidebarProps } from "components/InvoiceSidebar/InvoiceSidebar"

const InvoiceSidebars = () => {
    useLocationChange(invoiceSidebars.clear)

    async function handleClose(props: IInvoiceSidebarProps) {
        if (typeof props.onClose === "function") {
            props.onClose()
        }
        invoiceSidebars.hide(props)
    }

    return (
        <>
            {useList(invoiceSidebars.list, (props: IInvoiceSidebarProps, idx) => (
                <InvoiceSidebar
                    key={idx}
                    {...props}
                    onClose={() => handleClose(props)}
                />
            ))}
        </>
    )
}

export default InvoiceSidebars
